export default __webpack_public_path__ + "static/eh_uma_boa-265029bb94b64257a1699976ca46207f.jpeg";